import React, { Component } from "react";
import { ButtonToolbar, Table, Grid } from 'react-bootstrap';

import { PropTypes } from 'prop-types';
import { LoadingSpinner } from '../../LoadingSpinner';
import { PaginationBuilder } from '../../PaginationBuilder';
import { TableButton } from '../../TableButton';
import { SearchHelper } from '../../helpers/SearchHelper';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { SelectOptionsHelper } from "../../helpers/SelectOptionsHelper";

export class DraftPOIs extends Component {
    static contextTypes = {
        edition: PropTypes.object
    }

    // ----------
    
    getPointOfInterestTypeLabel(value) {
        const pointOfInterestType = SelectOptionsHelper.PointOfInterestTypes.find(x => x.value === value);
        if(undefined === pointOfInterestType) {
            return SelectOptionsHelper.PointOfInterestTypes.find(x => x.value === 0).label
        }

        return pointOfInterestType.label;
    }

    // ----------

    sortPOIs(a, b) {
        let aName = a.name;
        let bName = b.name;

        if ("object" === typeof aName) {
            aName = undefined !== aName.left ? aName.left : aName.right;
        }

        if ("object" === typeof bName) {
            bName = undefined !== bName.left ? bName.left : bName.right;
        }

        return aName !== bName ? aName < bName ? -1 : 1 : 0;
    }

    // -----------------------

    renderLoading(isLoading) {
        if (isLoading) {
            return (
                <LoadingSpinner />
            );
        }

        return null;
    }

    renderType(value) {
        if (value === undefined) {
            return null;
        }

        return this.getPointOfInterestTypeLabel(value);
    }

    renderWorkingHours(value) {
        if (value === undefined) {
            return null;
        }

        return (
            value.map((wh, i) => <li key={`poi-wh-${i}`}>{wh}</li>)
        );
    }

    renderContacts(value) {
        if (value === undefined) {
            return null;
        }

        return (
            value.map((ct, i) => <li key={`poi-ct-${i}`}>{ct}</li>)
        );
    }

    render() {
        const { edition } = this.context;

        if (null === edition || undefined === edition) {
            return null;
        }

        const { pois, isLoading, currentPage, elementsPerPage, filter } = this.props;

        const poisFiltered = SearchHelper.search({
            filter: filter,
            data: pois,
            fields: ["name", "description", "type", "coordX", "coordY"],
            callbackComparison: [
                { "type": (t) => this.getPointOfInterestTypeLabel(t) }
            ]
        });

        const totalPages = PaginationHelper.getTotalPages(poisFiltered.length, elementsPerPage);
        const activePage = totalPages < currentPage ? totalPages : currentPage;
        const poisToRender = poisFiltered.sort((a, b) => this.sortPOIs(a, b))
            .slice((activePage - 1) * elementsPerPage, activePage * elementsPerPage);

        return (
            <Grid fluid className="table-small-screens">
                <div className="table-loading">
                    <Table responsive striped hover >
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>Descrição</th>
                                <th>Tipo</th>
                                <th>Latitude</th>
                                <th>Longitude</th>
                                <th>Edição</th>
                                <th>Horários de funcionamento</th>
                                <th>Contactos</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody className={isLoading ? "overlay" : ""}>
                            {
                                poisToRender.map((poi, idx) =>
                                    <tr key={`poi-${idx}`}>
                                        <td>{poi.name}</td>
                                        <td>{poi.description}</td>
                                        <td>{this.renderType(poi.type)}</td>
                                        <td>{poi.coordX}</td>
                                        <td>{poi.coordY}</td>
                                        <td>{edition.getDraftCountyEditionName(poi.countyEditionId)}</td>
                                        <td>{this.renderWorkingHours(poi.workingHours)}</td>
                                        <td>{this.renderContacts(poi.contacts)}</td>
                                        <td>
                                            <ButtonToolbar className="pull-right">
                                                <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.props.onEditClick(poi)} />
                                                <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.props.onDeleteClick(poi)} />
                                            </ButtonToolbar>
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </Table >
                    <PaginationBuilder
                        currentPage={currentPage}
                        elementsPerPage={elementsPerPage}
                        dataLength={poisFiltered.length}
                        onChangePage={(a) => this.props.onChangePage(a)}
                        onChangeElementsPerPage={(a) => this.props.onChangeElementsPerPage(a)} />

                    {this.renderLoading(isLoading)}
                </div>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/pointsOfInterest/DraftPOIsList.js